/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyAdminRepresentation,
  CompanyCreateRequest,
  CompanyRepresentation,
  CompanyUpdateRequest,
} from '../models/index';
import {
    CompanyAdminRepresentationFromJSON,
    CompanyAdminRepresentationToJSON,
    CompanyCreateRequestFromJSON,
    CompanyCreateRequestToJSON,
    CompanyRepresentationFromJSON,
    CompanyRepresentationToJSON,
    CompanyUpdateRequestFromJSON,
    CompanyUpdateRequestToJSON,
} from '../models/index';

export interface CreateCompanyRequest {
    companyCreateRequest?: CompanyCreateRequest;
}

export interface CreateCompanyAdminRequest {
    companyKey: string;
    userKey: string;
}

export interface DeleteCompanyRequest {
    key: string;
}

export interface DeleteCompanyAdminRequest {
    companyKey: string;
    userKey: string;
}

export interface GetCompaniesRequest {
    allGenerators?: Array<string>;
}

export interface GetCompanyRequest {
    key: string;
}

export interface GetCompanyAdminsRequest {
    key: string;
}

export interface UpdateCompanyRequest {
    key: string;
    companyUpdateRequest?: CompanyUpdateRequest;
}

/**
 * 
 */
export class CompaniesApi extends runtime.BaseAPI {

    /**
     * Create a new Company
     * Create a new Company
     */
    async createCompanyRaw(requestParameters: CreateCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyRepresentation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyCreateRequestToJSON(requestParameters['companyCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new Company
     * Create a new Company
     */
    async createCompany(companyCreateRequest?: CompanyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyRepresentation> {
        const response = await this.createCompanyRaw({ companyCreateRequest: companyCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a company admin
     * Promote user
     */
    async createCompanyAdminRaw(requestParameters: CreateCompanyAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['companyKey'] == null) {
            throw new runtime.RequiredError(
                'companyKey',
                'Required parameter "companyKey" was null or undefined when calling createCompanyAdmin().'
            );
        }

        if (requestParameters['userKey'] == null) {
            throw new runtime.RequiredError(
                'userKey',
                'Required parameter "userKey" was null or undefined when calling createCompanyAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies/{companyKey}/admins/{userKey}`;
        urlPath = urlPath.replace(`{${"companyKey"}}`, encodeURIComponent(String(requestParameters['companyKey'])));
        urlPath = urlPath.replace(`{${"userKey"}}`, encodeURIComponent(String(requestParameters['userKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a company admin
     * Promote user
     */
    async createCompanyAdmin(companyKey: string, userKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCompanyAdminRaw({ companyKey: companyKey, userKey: userKey }, initOverrides);
    }

    /**
     * Delete the company
     * Delete the company
     */
    async deleteCompanyRaw(requestParameters: DeleteCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the company
     * Delete the company
     */
    async deleteCompany(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompanyRaw({ key: key }, initOverrides);
    }

    /**
     * Removes the company admin role of a user
     * Degrade a company admin
     */
    async deleteCompanyAdminRaw(requestParameters: DeleteCompanyAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['companyKey'] == null) {
            throw new runtime.RequiredError(
                'companyKey',
                'Required parameter "companyKey" was null or undefined when calling deleteCompanyAdmin().'
            );
        }

        if (requestParameters['userKey'] == null) {
            throw new runtime.RequiredError(
                'userKey',
                'Required parameter "userKey" was null or undefined when calling deleteCompanyAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies/{companyKey}/admins/{userKey}`;
        urlPath = urlPath.replace(`{${"companyKey"}}`, encodeURIComponent(String(requestParameters['companyKey'])));
        urlPath = urlPath.replace(`{${"userKey"}}`, encodeURIComponent(String(requestParameters['userKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes the company admin role of a user
     * Degrade a company admin
     */
    async deleteCompanyAdmin(companyKey: string, userKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompanyAdminRaw({ companyKey: companyKey, userKey: userKey }, initOverrides);
    }

    /**
     * Return all companies
     * Return all companies
     */
    async getCompaniesRaw(requestParameters: GetCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanyRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['allGenerators'] != null) {
            queryParameters['all_generators'] = requestParameters['allGenerators']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyRepresentationFromJSON));
    }

    /**
     * Return all companies
     * Return all companies
     */
    async getCompanies(allGenerators?: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanyRepresentation>> {
        const response = await this.getCompaniesRaw({ allGenerators: allGenerators }, initOverrides);
        return await response.value();
    }

    /**
     * Return the company with the specified key
     * Return a company
     */
    async getCompanyRaw(requestParameters: GetCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyRepresentationFromJSON(jsonValue));
    }

    /**
     * Return the company with the specified key
     * Return a company
     */
    async getCompany(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyRepresentation> {
        const response = await this.getCompanyRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Return all company admins
     * Return all company admins
     */
    async getCompanyAdminsRaw(requestParameters: GetCompanyAdminsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompanyAdminRepresentation>>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getCompanyAdmins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies/{key}/admins`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyAdminRepresentationFromJSON));
    }

    /**
     * Return all company admins
     * Return all company admins
     */
    async getCompanyAdmins(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompanyAdminRepresentation>> {
        const response = await this.getCompanyAdminsRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Update the company
     * Update the company
     */
    async updateCompanyRaw(requestParameters: UpdateCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/companies/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyUpdateRequestToJSON(requestParameters['companyUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyRepresentationFromJSON(jsonValue));
    }

    /**
     * Update the company
     * Update the company
     */
    async updateCompany(key: string, companyUpdateRequest?: CompanyUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyRepresentation> {
        const response = await this.updateCompanyRaw({ key: key, companyUpdateRequest: companyUpdateRequest }, initOverrides);
        return await response.value();
    }

}
